// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__6Gjcf"};